import script from "./CInputNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./CInputNumber.vue?vue&type=script&setup=true&lang=ts"

import "./CInputNumber.vue?vue&type=style&index=0&id=250506b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250506b2"]])

export default __exports__